const CustomInput = ({
  label,
  name,
  type = "text",
  register,
  validation = {},
  error,
  disabled = false,
  placeholder = "",
  className = "",
  ...props // Captures extra props like 'max', 'min', 'accept'
}) => {
  return (
    <div className={`w-full flex flex-col gap-2 ${className}`}>
      {label && (
        <label className="font-[400] text-xs text-gray-600">
          {label} {validation.required && <span className="text-red-400">*</span>}
        </label>
      )}
      <input
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        {...register(name, validation)}
        {...props}
        className={`border rounded-md px-3 py-2 text-sm w-full outline-none transition-colors ${
          disabled ? "bg-gray-50 cursor-not-allowed text-gray-500" : "bg-white"
        } ${
          error
            ? "border-red-500 focus:border-red-500"
            : "border-gray-300 focus:border-teal-700"
        }`}
      />
      {error && <span className="text-red-500 text-xs">{error.message}</span>}
    </div>
  );
};


export default CustomInput;